import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Text } from '@perch-labs/shrike';
import Graphic from '/images/graphics/rec-power.svg';
import { copyFor, routes } from 'config';
import { ErrorModule } from 'components/errors';
import { LoadingModule } from 'components/loading';
import { useImpactStats } from 'hooks/use-impact-stats.hook';
import { Card, Container } from 'styles';
import { BannerContent, StyledSVG } from './recs.style';

const getCopy = copyFor('modules.recs');

interface Props {
  withLink?: boolean;
}

export const RecsModule = (props: Props) => {
  const { planId } = useParams<{ planId?: string }>();
  const { recs } = routes({ planId });

  const { withLink = true } = props;
  const { data, error, loading } = useImpactStats({
    planId: Number(planId),
  });
  const history = useHistory();

  if (loading) return <LoadingModule variant="statCard" />;
  if (error || !data) return <ErrorModule title={getCopy('title')} />;

  const { kwh, totalRecsPurchased } = data.carbonEquivalency;

  const icon = (
    <Icon
      icon="ChevronRight"
      scale={3}
      title={getCopy('title')}
      color="secondary"
    />
  );

  let headerProps: any = {
    title: getCopy('title'),
  };
  if (withLink) {
    headerProps = {
      ...headerProps,
      icon,
      onClick: () => history.push(recs),
      to: recs,
    };
  }

  return (
    <Card mobileVariant="flat">
      <Card.Header {...headerProps} />
      <Card.Content>
        <Text opacity="medium">{getCopy('description')}</Text>
      </Card.Content>
      <Card.Banner>
        <BannerContent>
          <Container>
            <Text textStyle="heading900">{totalRecsPurchased.toFixed(1)}</Text>
            <Text>{getCopy('kwhText', { kwh })}</Text>
          </Container>
          <StyledSVG
            src={Graphic}
            height="216px"
            width="111px"
            aria-hidden="true"
          />
        </BannerContent>
      </Card.Banner>
    </Card>
  );
};
